import React, { useEffect, useMemo } from 'react';
import { useAtom } from 'jotai/index';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import styles from './css/index.module.scss';
import { isInitAtom, pathnameAtom } from '../../../../atoms/globalAtoms';
import useTranslations from '../../../../hooks/useTranslations';
import { projectsCountAtom } from '../../../../atoms/projectsAtoms';
import { DICTIONARY } from '../../../../translations/dictionary';
import useProjects from '../../../../hooks/useProjects';

// The projects page loads the count with its list, so it passes shouldLoadCount={false}.
function ProjectsNavigationBlocks({ className, shouldLoadCount = true }) {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const [pathname] = useAtom(pathnameAtom);
  const [isInit] = useAtom(isInitAtom);
  const [projectsCount] = useAtom(projectsCountAtom);
  const { refreshProjectsCount } = useProjects();
  const selectedTab = useMemo(() => (pathname === '/my-projects' ? 'projects' : pathname === '/configurations-history' ? 'history' : ''), [pathname]);

  const onProjectsClick = () => {
    navigate('/my-projects');
  };

  const onHistoryClick = () => {
    navigate('/configurations-history');
  };

  useEffect(() => {
    if (!isInit || !shouldLoadCount) return;
    refreshProjectsCount().then();
  }, [isInit, shouldLoadCount]);

  return (
    <div className={classNames(styles.navigationBlock, className)}>
      <div
        className={
          classNames(
            styles.navigationItem,
            { [styles.navigationItemSelected]: selectedTab === 'projects' },
            'pressable',
          )
      }
        style={{ width: '200px' }}
        onClick={onProjectsClick}
      >
        <p className={styles.navigationItemText}>{`${t(DICTIONARY.myProjects)}${projectsCount !== null ? ` (${projectsCount})` : ''}`}</p>
      </div>
      <div
        className={
          classNames(
            styles.navigationItem,
            { [styles.navigationItemSelected]: selectedTab === 'history' },
            'pressable',
          )
      }
        onClick={onHistoryClick}
      >
        <p className={styles.navigationItemText}>{t(DICTIONARY.configurationsHistory)}</p>
      </div>
    </div>
  );
}

export default ProjectsNavigationBlocks;
